import { render } from "./Title.vue?vue&type=template&id=445d38ce&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=445d38ce&scoped=true&lang=scss"

import exportComponent from "/Users/pepijnvdk/TNT/wewantyou/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445d38ce"]])

export default __exports__